import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { arrow, computePosition, flip, offset, shift, size } from '@floating-ui/dom';
import { ref, onMounted, unref, nextTick, onBeforeUnmount, watch, computed } from 'vue';
import * as _ from 'lodash';
import { VisibleMode, arrowPosition } from '../hint/enums';


export default /*#__PURE__*/_defineComponent({
  props: {
  content: [String, Number],
  placement: {
    type: String,
    default() {
      return 'top';
    }
  },
  visibleArrow: {
    type: Boolean,
    default() {
      return true;
    }
  },
  delayVisible: {
    type: Number,
    default() {
      return 0;
    }
  },
  delayHidden: {
    type: Number,
    default() {
      return 250;
    }
  },
  visibleMode: {
    type: String,
    default() {
      return VisibleMode.Auto;
    }
  },
  isVisible: {
    type: Boolean,
    default() {
      return false;
    }
  },
  maxWidth: {
    type: String,
    default() {
      return '';
    }
  },
  type: {
    type: String,
    default() {
      return 'dark';
    }
  }
},
  setup(__props) {

const props = __props



let hintVisible = ref(false);
let isMouseOver = ref(false);
const targetElement = ref<HTMLDivElement | null>(null);
const hintElement = ref<HTMLDivElement | null>(null);
const hintArrowElement = ref<HTMLDivElement | null>(null);

onMounted(() => {
  hintVisible.value = props.isVisible;
  checkHintPositionAndVisibility();
  window.addEventListener('scroll', checkHintPositionAndVisibility);
  window.addEventListener('resize', checkHintPositionAndVisibility);
});

watch(props, updateHintStyleAndPosition, { deep: true });

async function updateHintStyleAndPosition() {
  const middleware = [
    flip(),
    shift(),
    offset(8),
    hintArrowElement.value ? arrow({ element: unref(hintArrowElement) }) : null,
    size({
      apply() {
        Object.assign(unref(hintElement)?.style, {
          maxWidth: `${props.maxWidth}px`
        });
      }
    })
  ].filter((v) => !!v);

  const { x, y, placement, middlewareData } = await computePosition(unref(targetElement), unref(hintElement), {
    placement: props.placement,
    strategy: 'fixed',
    middleware
  });

  Object.assign(unref(hintElement)?.style, {
    left: `${x}px`,
    top: `${y}px`
  });

  if (props.visibleArrow) {
    const { arrow } = middlewareData;
    const staticSide = arrowPosition[placement.split('-')[0]];

    Object.assign(unref(hintArrowElement)?.style, {
      left: arrow?.x != null ? `${arrow.x}px` : '',
      top: arrow?.y != null ? `${arrow.y}px` : '',
      right: '',
      bottom: '',
      [staticSide]: '-4px'
    });
  }
}

function checkHintPositionAndVisibility() {
  if (!hintVisible.value) return;

  if (props.visibleMode === VisibleMode.Manual) {
    nextTick(updateHintStyleAndPosition);
  } else {
    setHintVisible(false);
  }
}

const showHint = () => {
  isMouseOver.value = true;
  setVisible();
};
const setVisible = _.debounce(() => setHintVisible(true), props.delayVisible);
const hideHint = () => {
  isMouseOver.value = false;
  setHidden();
};

const setHidden = _.debounce(() => setHintVisible(false), props.delayHidden);
const isVisibleHint = computed(() => hintVisible.value || (props.visibleMode === VisibleMode.Manual && props.isVisible));

function setHintVisible(isShow: boolean) {
  if (props.visibleMode === VisibleMode.Manual) return;
  if (isShow && !isMouseOver.value) return;
  hintVisible.value = isShow;
  nextTick(updateHintStyleAndPosition);
}

onBeforeUnmount(() => {
  window.removeEventListener('scroll', checkHintPositionAndVisibility);
  window.removeEventListener('resize', checkHintPositionAndVisibility);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "targetElement",
    ref: targetElement,
    onMouseenter: showHint,
    onMouseleave: hideHint,
    class: "n-hint"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['n-hint__body', `n-hint__body_${__props.type}`]),
        ref_key: "hintElement",
        ref: hintElement
      }, [
        _renderSlot(_ctx.$slots, "content", {}, () => [
          _createTextVNode(_toDisplayString(__props.content), 1)
        ]),
        (__props.visibleArrow)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "n-hint__arrow",
              ref_key: "hintArrowElement",
              ref: hintArrowElement
            }, null, 512))
          : _createCommentVNode("", true)
      ], 2), [
        [_vShow, _unref(isVisibleHint)]
      ])
    ]))
  ], 544))
}
}

})